import axios from 'axios';

function trimTrailingSlash(value) {
    return value.replace(/\/+$/, '');
}

function getDefaultApiBase() {
    if (typeof window === 'undefined') {
        return 'http://localhost:3000';
    }

    const {origin} = window.location;
    if (origin.includes(':8080')) {
        return origin.replace(':8080', ':3000');
    }

    return 'https://portfolio.arthur-keusch.fr:3000';
}

const RAW_API_BASE = process.env.VUE_APP_API_BASE_URL || getDefaultApiBase();
const API_BASE = trimTrailingSlash(RAW_API_BASE);
const MEDIA_BASE = trimTrailingSlash(process.env.VUE_APP_MEDIA_BASE_URL || API_BASE);

const api = axios.create({
    baseURL: `${API_BASE}/api`,
    withCredentials: true,
});

export function buildApiUrl(route = '') {
    const normalizedRoute = String(route || '').replace(/^\/+/, '');
    return `${API_BASE}/api/${normalizedRoute}`;
}

export function getMediaUrl(path = '') {
    if (!path) {
        return '';
    }

    if (path.startsWith('http') || path.startsWith('data:')) {
        return path;
    }

    return `${MEDIA_BASE}${path.startsWith('/') ? path : `/${path}`}`;
}

export async function GetRequest(route, params = {}) {
    const response = await api.get(`/${route}`, {params});
    return response.data;
}

export async function PostRequest(route, data = {}, config = {}) {
    const response = await api.post(`/${route}`, data, config);
    return response.data;
}

export async function PutRequest(route, data = {}, config = {}) {
    const response = await api.put(`/${route}`, data, config);
    return response.data;
}

export async function DeleteRequest(route) {
    const response = await api.delete(`/${route}`);
    return response.data;
}
